import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { GestoresService } from 'src/app/services/gestores.service';
import { __param } from 'tslib';
import sortBy from 'sort-by';
import { Utils } from 'src/app/utils/utils';
import { RelatorioEmail } from 'src/app/models/relatorioEmail.model';
import { Eleicao } from 'src/app/models/eleicao.model';
import { RelatorioEvento } from 'src/app/models/relatorioEvento.model';



@Component({
  selector: 'app-table-relatorio-email-detalhado',
  templateUrl: './table-relatorio-email-detalhado.component.html',
  styleUrls: ['./table-relatorio-email-detalhado.component.css']
})
export class TableRelatorioEmailDetalhadoComponent implements OnInit {

  public eventos: RelatorioEvento[] = [];
  public email: RelatorioEmail;
  public token: any;
  public eleicao: Eleicao;
  public idEmail: number;

  
  @Input() eleicaoId: number;
  logo: any;
  offset: number;
  
  constructor(
    protected gestoresService: GestoresService,
    public spinner: NgxSpinnerService,
    protected router: Router,
    public utils: Utils
    ) {}
    
  ngOnInit() {
    this.spinner.show();
    this.token = sessionStorage.getItem("token");
    this.idEmail = Number(sessionStorage.getItem("idEmail"));
    this.getEventos(this.eleicaoId, this.token, this.idEmail);
    // var logoRaw = sessionStorage.getItem("logoeleicao");
    // this.logo = logoRaw
  }

 async getEventos(idEleicao: number, token: any, idEmail: number) {
    this.gestoresService.getRelatorioEmailDetalhado(idEleicao, token, idEmail).then((emails: RelatorioEmail) => {
      this.email = emails;
      this.eventos = emails.eventos;
      this.spinner.hide();
    }).catch(err => {
      this.router.navigate(['/error-sessao']);
    });
  }

  separarDataHora(valor) {
    const dataHora = valor.hora.split("T");
    const separarHora = dataHora[1].split(".");
    const invertendoData = dataHora[0].split("-");
    const dataAno = invertendoData[0];
    const dataMes = invertendoData[1];
    const dataDia = invertendoData[2];
    const dataFormatada = dataDia + "/" + dataMes + "/" + dataAno

    return { data: dataFormatada, hora: separarHora[0] };
  }

  exportParaExcel(){
    let dadosResultado = this.eventos;
    this.utils.exportRelatorioDetalhadoEmailParaExcel(this.email, dadosResultado);
  }

}
